export default __webpack_public_path__ + "static/media/map.51914d21.svg";